module.exports = __webpack_public_path__ + "static/sat10am-dee0e47c90aaa72176c20f1caa65fef6.svg";